<script lang="ts">
  export let disabled = false;
  export let outline = false;
  export let style;
</script>

<button {disabled} {style} on:click class:outline>
  <slot/>
</button>

<style lang="scss">
  button {
    cursor: pointer;
    display: block;
    background: #333333;
    color: #fff;
    width: 100%;
    border: none;
    border-radius: 6px;
    height: 42px;
    font-size: 14px;
    font-weight: 600;
    // line-height: 42px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    margin-top: 0.85rem;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.3;
      box-shadow: none;
    }

    &.outline {
      background: #fff;
      color: #333;
      border: 1px solid #333
    }
  }
</style>
